/**
 * 营运中心--》送货流程相关
 */

export default {
  // 开启智能送货功能入口
  intelligent_delivery: ['82635', '90100', '82380', '68199', '83734', '98565'],
  // 要求到货库存里面的运单右击菜单可以办理：客户提货、终端代理 https://imagecdn.ymm56.com/ymmfile/static/resource/6e841ffb-e5e9-4191-80da-b008e77fb524.png
  right_menu_in_arrival_inventory: ['98235'],
  self_pickup_delivery: ['69501'], // 自提不能安排送货
  // 送货安排，修复挑单后表格展示重复数据
  fix_repeating_delivery_data: ['96811', '90816', '97993', '90100', '82635'], // 202508051249470677237、202503061806394136170
  old_home_delivery_weight_apportion:['81068','77162', '73770','82380','82635'],//送货上门列表 原来定制按重量分摊，且使用的参数为sendweight https://imagecdn.ymm56.com/ymmfile/static/resource/e0a8cbf4-7246-4a9e-9b57-e22ab9f3c9bb.png
  share_delivery_costs_default_billing_weight:['85780'],//202508281017294009958 85780 送货上门 ==> 送货安排，送货调整，分摊送货费默认选中按计费重量分摊 https://imagecdn.ymm56.com/ymmfile/static/resource/aa17961b-959b-4085-a524-97c524e67909.png
  customer_pick_up_inventory_search:['93081'],//202509261654537104428 93081客户提货-提货库存新增按单号或号码查询
  terminal_agent_default_pick_up_all:['99398'],//202510101408370038660 99398终端代理默认提取全部到全部的订单
}
